import styled from 'styled-components';
import { textStyles, token } from '@bynder/design-system';

export const AlertContent = styled.div<{ backgroundColor: string }>`
    display: flex;
    gap: ${token.spacing3};
    padding: ${token.spacing4};
    padding-right: ${token.spacing5};
    border-radius: ${token.radiusBase};
    background-color: ${({ backgroundColor }) => backgroundColor};
`;

export const AlertIconWrapper = styled.div`
    flex-shrink: 0;
`;

export const AlertBodyWrapper = styled.div`
    ${textStyles.paragraphS};
    white-space: pre-line;
    min-width: 0;
    overflow-wrap: break-word;
`;
